// extracted by mini-css-extract-plugin
export default {"videoContainer":"PanoptoEmbed_videoContainer__2Xbtm","gradientShift":"PanoptoEmbed_gradientShift__HOqm3","videoWrapper":"PanoptoEmbed_videoWrapper__bvz8g"};